import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';
import { AppConstants } from 'src/app/constants/app-constants';
import { environment } from 'src/environments/environment';

export interface Config {
  clientId: string;
  issuerUrl: string;
  scope: string;
  logoutUrl: string;
  dppApiUrl: string;
  lpStatusApiUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthConfigService {

  config: Config;
  isPublic = true;
  constructor(private http: HttpClient) { }

  loadAuthConfig(): Promise<any> {
    const configUrl = './assets/env/config.' + this.getConfigEnvironment(environment.environment) + '.json';

    return this.http
      .get<Config>(configUrl + '?noCache=' + new Date().getTime())
      .toPromise()
      .then(config => {
        this.config = config;
      });
  }

  public getConfig(): Config {

    if (!this.config) {
      console.log('config is NULL');
      async () => {
        await this.loadAuthConfig();
      };
      console.log('config has been re-initialized');
    }

    return this.config;
  }

  private getConfigEnvironment(envt: string): string {
    return (envt === AppConstants.ENVT_DEV) || (envt === AppConstants.ENVT_LOCAL) ? AppConstants.CNFG_ENVT_DEV :
      envt === AppConstants.ENVT_SI ? AppConstants.CNFG_ENVT_SI : AppConstants.CNFG_ENVT_PROD;
  }

  getAuthConfig(): AuthConfig {
    return {
      // Url of the Identity Provider
      issuer: this.config?.issuerUrl,
      // URL of the SPA to redirect the user to after login
      redirectUri:
        window.location.origin +
        (localStorage.getItem('useHashLocationStrategy') === 'true'
          ? '/#/auth-callback'
          : '/auth-callback'),

      // The SPA's id. The SPA is registerd with this id at the auth-server
      // clientId: 'server.code',
      clientId: this.config?.clientId,

      // Just needed if your auth server demands a secret. In general, this
      // is a sign that the auth server is not configured with SPAs in mind
      // and it might not enforce further best practices vital for security
      // such applications.
      // dummyClientSecret: 'secret',

      responseType: 'code',

      // set the scope for the permissions the client should request
      // The first four are defined by OIDC.
      // Important: Request offline_access to get a refresh token
      // The api scope is a usecase specific one
      scope: this.config?.scope,

      showDebugInformation: true,

      clearHashAfterLogin: true,
      silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
      silentRefreshTimeout: 5000,
      useSilentRefresh: true, // Needed for Code Flow to suggest using iframe-based refreshes
      timeoutFactor: 0.8, // call silent refresh when 80% time reached,
      nonceStateSeparator: 'semicolon',
      logoutUrl: this.config?.logoutUrl
    };
  }
}




